import styled from '@emotion/styled';
import Phone from '@engineering/icons/phone';
import { Link } from '../Link';

const PhoneNumberIcon = styled(Phone)`
  fill: currentcolor;
  width: 1.5rem;
  height: 1.5rem;
`;

const ContactWrapper = styled.div`
  border-radius: 0.75rem;
  text-align: center;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.neutral.grey20};
`;

const ContactTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 0.5rem;
`;

const ContactText = styled.p`
  padding-bottom: 1rem;
`;

const ContactNumber = styled.div`
  display: inline-flex;
  gap: 0.5rem;
  padding: 0;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1.25rem;
  white-space: nowrap;
`;

const ContactButton = styled(Link)`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.brand.green140};
  text-decoration: none;
`;

const Headline = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  margin-bottom: 1.5rem;
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[20]};

  & > * {
    width: 326px;
  }

  ${({ theme }) => theme.mq('sm')} {
    gap: ${({ theme }) => theme.spacing[40]};

    & > * {
      width: 385px;
    }
  }

  ${({ theme }) => theme.mq('xl')} {
    gap: ${({ theme }) => theme.spacing[50]};
    justify-content: flex-start;
  }
`;

const TopBorderWrapper = styled.div`
  ${({ theme }) => theme.mq('md')} {
    border-top: 3px solid;
    border-color: ${({ theme }) => theme.colors.brand.green100};
    padding-block: 1rem;
  }

  ${({ theme }) => theme.mq('lg')} {
    padding-block: 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-direction: column;

  ${({ theme }) => theme.mq('md')} {
    flex-direction: row;
  }
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ theme }) => theme.mq('md')} {
    max-width: 100%;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  max-width: 100%;
  margin-top: 2rem;

  ${({ theme }) => theme.mq('md')} {
    max-width: 50%;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const Title = styled.h1`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  margin: 0;
`;

const Subtitle = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  margin: 0;
`;

const Description = styled.p`
  margin: 0;
`;

const InfoCardsWrapper = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

export {
  Container,
  InfoCardsWrapper,
  ImageWrapper,
  Title,
  Subtitle,
  Description,
  Wrapper,
  TopBorderWrapper,
  CardContainer,
  Headline,
  ContactWrapper,
  ContactTitle,
  ContactText,
  ContactNumber,
  ContactButton,
  PhoneNumberIcon,
};
